module.exports = __webpack_public_path__ + "img/eastcool-rgb.7e4c81c.png";